<style>
    .text-danger {
    color: #ff4444 ;
    }
    .card-header-formatting {
    padding-top: 16px;
    padding-bottom: 16px;
    background: linear-gradient(112.2deg, var(--sl-color-primary-400) 14.86%, var(--sl-color-primary-700) 102.08%);
    color: white;
  }
  .card-header-formatting a:visited{
    color: #f7be6a;
  }
  .pii-text {
    margin-top:0px; 
    padding:0px 0px 0px 10px;
    font-size:10px;
  }
  @media screen and (min-width: 1400px) {
    #middle-name-radio-group {
        padding: 12px 0px;
    }
   }

</style>
    

<div [formGroup]="candidate">
    <fadv-grid>
        <fadv-grid-row>
            <fadv-grid-col>
                <fadv-typography type="label-medium" weight="500">Applicant Information</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col>
                <fadv-typography type="label-small">{{ legalNameTooltip }}</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box>
                    <fadv-input 
                    [invalid]="this?.firstNameInvalid"
                    (blur)="this?.showValidation('firstName')" 
                    autofocus="autofocus" [readonly]="disableFirstName" 
                    formControlName="firstName" label="Legal First Name *" 
                    type="text"></fadv-input>
                    <span *ngIf="this?.firstNameInvalid == true">
                        <small *ngIf="candidate.get('firstName').hasError('required')" class="text-danger">First Name is Required</small>
                        <small *ngIf="candidate.get('firstName').hasError('pattern')" class="text-danger">First Name cannot contain numbers</small>
                        <small *ngIf="candidate.get('firstName').hasError('whitespace') && !candidate.get('firstName').hasError('required')" class="text-danger">First Name cannot be empty</small>
                    </span>
                </fadv-box>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input 
                [invalid]="this?.lastNameInvalid"
                (blur)="this?.showValidation('lastName')" 
                [readonly]="disableLastName" formControlName="lastName" 
                label="Legal Last Name *" type="text"></fadv-input>
                <span *ngIf="this?.lastNameInvalid == true">
                    <small *ngIf="candidate.get('lastName').hasError('required')" class="text-danger">Last Name is Required</small>
                    <small *ngIf="candidate.get('lastName').hasError('pattern')" class="text-danger">Last Name cannot contain numbers</small>
                    <small *ngIf="candidate.get('lastName').hasError('whitespace') && !candidate.get('lastName').hasError('required')" class="text-danger">Last Name cannot be empty</small>
                </span>
            </fadv-grid-col>
        </fadv-grid-row>
        <fadv-grid-row>  
                <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                    <fadv-box [mv]="{ xxl: 'large', xl: 'large', md: 'large', sm: 'small', xs: 'small'}">
                    <div id="middle-name-radio-group">
                        <fadv-radio-group [fieldset]="false" formControlName="middleNameRequired" fieldset="true" label="{{ middleNameLabel }} have a middle name?">
                        <fadv-grid>
                            <fadv-grid-row>
                                <fadv-grid-col [col]="{ xxl: 8, xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }">
                                    <fadv-typography type="label-small">{{ middleNameLabel }} have a middle name?</fadv-typography>
                                </fadv-grid-col>
                                <fadv-grid-col [col]="{ xxl: 2, xl: 3, lg: 3, md: 4, sm: 3, xs: 3 }">
                                    <fadv-radio  name="option" [checked]='!requireMiddleName' value="0">No</fadv-radio>
                                </fadv-grid-col>
                                <fadv-grid-col [col]="{ xxl: 2, xl: 3, lg: 3, md: 4, sm: 3, xs: 3 }">
                                    <fadv-radio  [checked]='requireMiddleName' name="option" value="1">Yes</fadv-radio>
                                </fadv-grid-col>
                            </fadv-grid-row>
                        </fadv-grid>
                    </fadv-radio-group>
                    </div>
                </fadv-box>
                </fadv-grid-col>
                <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }"  *ngIf="requireMiddleName == true">
                    <fadv-box [mv]="{ xxl: 'large', xl: 'large', md: 'large', sm: 'medium', xs: 'medium'}">
                    <fadv-input
                     [invalid]="this?.middleNameInvalid"
                     (blur)="this?.showValidation('middleName')" 
                     [readonly]="disableMiddleName" formControlName="middleName" 
                     label="Legal Middle Name *" type="text"></fadv-input>
                    <span *ngIf="this?.middleNameInvalid == true">
                        <small *ngIf="candidate.get('middleName').hasError('pattern')" class="text-danger">Middle Name cannot contain numbers</small>
                        <small *ngIf="candidate.get('middleName').hasError('whitespace') && !candidate.get('middleName').hasError('required')" class="text-danger">Middle Name cannot be empty</small>
                    </span>
                </fadv-box>
                </fadv-grid-col>
        </fadv-grid-row>

        <fadv-grid-row>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-input
                [invalid]="this?.ssnInvalid"
                 (blur)="this?.showValidation('ssn')"
                  formControlName="ssn" 
                 (focused)="unobstructSSN($event)" 
                 (blurred)="obstructSSN($event)" 
                 [maxlength]="9" [minlength]="9" 
                 type="text" label="Social Security Number *"></fadv-input>
                <p class="pii-text">We do not share social security numbers</p>
                <div>
                    <span *ngIf="this?.ssnInvalid == true">
                        <small *ngIf="candidate.get('ssn').hasError('required')" class="text-danger">Social Security Number is Required</small>
                        <small *ngIf="candidate.get('ssn').hasError('minlength') || candidate.get('ssn').hasError('pattern')" class="text-danger">Social Security Number must be Nine digits</small>
                    </span>
                </div>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" *ngIf="hideDatePicker == false">
                <fadv-date-picker (blur)="this?.showValidation('dob')" (blur)="obstructDob($event)" #fadvDatePicker 
                [invalid]="this?.candidate.get('dob').hasError('birthday') || this?.candidate.get('dob').hasError('tooOld')" 
                [max]="maximumYear" (focus)="assignTempValue($event)" (blur)="handleDob($event)" label="Date of Birth *" variant="primary"></fadv-date-picker>
                <p class="pii-text">We do not share birth dates</p>
                <div>
                    <span *ngIf="this?.dobInvalid == true">
                        <small *ngIf="this?.candidate.get('dob').hasError('birthday')" class="text-danger">Please enter a valid date of birth</small> 
                        <small *ngIf="this?.candidate.get('dob').hasError('tooOld')" class="text-danger">Date of birth cannot be more than 150 years ago</small> 
                    </span>
                </div>
            </fadv-grid-col>

            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }" *ngIf="hideDatePicker == true">
                <div (mouseenter)="unobstructDob($event)">
                    <fadv-input (focus)="this.hideDatePicker = false" label="Date of Birth *" variant="primary" value="**/**/****" [valid]="true"></fadv-input>
                </div>
                <fadv-typography type="label-xx-small" weight="400">We do not share birth dates</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row>
        <!-- <fadv-grid-row>
            <fadv-grid-col style="padding-bottom: 8px; padding-top: 8px;">
                <fadv-typography type="paragraph-small" variant="neutral">Don't worry, we don't share your {{ ssnMessage }} full social security number or date of birth.</fadv-typography>
            </fadv-grid-col>
        </fadv-grid-row> -->
        <fadv-grid-row *ngIf="order === 'online'">
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
              <fadv-input 
              [invalid]="this?.emailInvalid"
              (blur)="this?.showValidation('email')" 
              formControlName="email" 
              type="email" label="Email *"></fadv-input>
              <span *ngIf="this?.emailInvalid == true">
              <small *ngIf="candidate.get('email').hasError('email')" class="text-danger">Email is Required</small>
              </span>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
              <fadv-input 
              [invalid]="this?.confirmEmailInvalid"
              (blur)="this?.showValidation('confirmEmail')"
              formControlName="confirmEmail" 
              type="email" label="Confirm Email *"></fadv-input>
              <small *ngIf="this?.confirmEmailInvalid == true" class="text-danger">Email must match</small>
            </fadv-grid-col>
          </fadv-grid-row>
        <fadv-grid-row *ngIf="requireDL">
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box>
                    <fadv-input 
                    [invalid]="this?.dlNumberInvalid"
                    (blur)="this?.showValidation('dlNumber')" 
                    formControlName="dlNumber" 
                    type="text" label="Drivers License Number *"></fadv-input>
                    <span *ngIf="this?.dlNumberInvalid == true">
                        <small *ngIf="candidate.get('dlNumber').hasError('required')" class="text-danger">Drivers License Number is Required</small>
                        <small *ngIf="candidate.get('dlNumber').hasError('whitespace') && !candidate.get('dlNumber').hasError('required')" class="text-danger">Drivers License Number cannot be empty</small>
                    </span>
                </fadv-box>
            </fadv-grid-col>
            <fadv-grid-col [col]="{ xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }">
                <fadv-box>
                    <fadv-input 
                    [invalid]="this?.dlStateInvalid"
                    (blur)="this?.showValidation('dlState')" 
                    oninput="this.value = this.value.toUpperCase()"
                    minlength="2" maxlength="2" autocapitalize="on" 
                    formControlName="dlState" 
                    type="text" label="Drivers License State Abbr *"></fadv-input>
                    <span *ngIf="this?.dlStateInvalid == true">
                        <small *ngIf="candidate.get('dlState').hasError('required')" class="text-danger">Drivers License State is Required</small>
                        <small *ngIf="candidate.get('dlState').hasError('minlength') || candidate.get('dlState').hasError('pattern')" class="text-danger">Drivers License State must be two letters</small>
                    </span>
                </fadv-box>
            </fadv-grid-col>
        </fadv-grid-row>
    </fadv-grid>
</div>
